import angular from "angular";

angular
    .module('app')
    .component('deleteLessonModal', {
        template: require('./delete-lesson-modal.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$scope', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier, $scope) {

    let $ctrl = this;
    $ctrl.students = null;

    $ctrl.$onInit = function () {
        $ctrl.lesson = $ctrl.resolve.lesson;
        $ctrl.course = $ctrl.resolve.course;
        $ctrl.getActiveStudents();
    };

    $ctrl.getActiveStudents = function () {
        $http
            .get(`/admin/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}/getActiveStudents`)
            .then(
                function (response) {
                    $ctrl.students = response.data;
                },
                function (error) {

                }
            );
    }

    $ctrl.deleteLesson = function () {
        $http.delete(`/admin/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}`).then(
                function (response) {
                    Notifier.success('Урок успешно удален', 2);
                    window.location = `/admin/courses/${$ctrl.course.id}/lessons`;
                },
                function () {
                    Notifier.error('Произошла ошибка', 2)
                }
            );
    }

}
